import React from "react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Tabs, Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    color: theme.palette.text.primary,
  },
}));

const TopBarMenuItems = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div>
      <Tabs>
        <Tab
          label={
            <Typography variant="h5" className={classes.tabs}>
              {t("pages.pricelist.title")}
            </Typography>
          }
          onClick={() => navigate("/pricelist")}
        />
        <Tab
          label={
            <Typography variant="h5" className={classes.tabs}>
              {t("pages.about.title")}
            </Typography>
          }
          onClick={() => navigate("/about")}
        />
        <Tab
          className={classes.tabs}
          label={
            <Typography variant="h5" className={classes.tabs}>
              {t("pages.contact.title")}
            </Typography>
          }
          onClick={() => navigate("/contact")}
        />
      </Tabs>
    </div>
  );
};

export default TopBarMenuItems;
